"use strict";

var Backbone = require('backbone');


var AppointmentModel = Backbone.Model.extend({
  /*
   * Holds the appointment information, ie the
   * array of appointment choices, and the value
   * of the selected appointment
   */
  validate: function() {
    if (this.get('selected_appointment')) return;
    return 'invalid';
  },

  etdChanged: function(model, options) {
    this.unset('appointments');
    this.unset('selected_appointment');
  },

  initialize: function() {
    this.on('change:etd', this.etdChanged);
  }
});

module.exports = {
  AppointmentModel: AppointmentModel
};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/departure/models.js
 **/